<template>
  <div :id="id" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: 'RelationalGraph',
  props: ['graphData', 'id', 'force', 'showEdge'],
  data() {
    return {
      coAuthor: null,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getOption();
    });
  },
  watch: {
    graphData: {
      handler() {
        this.getOption();
      },
    },
    showEdge: {
      handler() {
        this.getOption();
      },
    },
  },
  methods: {
    getOption() {
      let _this = this;
      this.coAuthor = this.$echarts.init(document.getElementById(this.id));
      let data = {
        nodes: this.graphData.nodes,

        links: this.graphData.links,
      };

      const color1 = '#FFAC41';
      const color2 = '#A9C6FF';
      const color3 = '#ACEEDC';

      data.nodes.forEach((node) => {
        if (node.category === 0) {
          node.symbolSize = 40;
          node.itemStyle = {
            color: color1,
          };
        } else if (node.category === 1) {
          node.symbolSize = 30;
          node.itemStyle = {
            color: color2,
          };
        } else if (node.category === 2) {
          node.symbolSize = 36;
          node.itemStyle = {
            color: color3,
          };
        }
      });

      data.links.forEach((link) => {
        link.label = {
          align: 'center',
          fontSize: 12,
        };
      });
      let option = {
        backgroundColor: this.$echarts.graphic.RadialGradient(0.3, 0.3, 0.8, [
          {
            offset: 0,
            color: '#f7f8fa',
          },
          {
            offset: 1,
            color: '#cdd0d5',
          },
        ]),
        // tooltip: {},
        series: [
          {
            type: 'graph',
            layout: 'force',
            symbolSize: 58,
            animation: false,
            edgeSymbol: ['', 'arrow'],
            // edgeSymbolSize: [80, 10],
            edgeLabel: {
              normal: {
                show: this.showEdge,
                textStyle: {
                  fontSize: 20,
                },
                formatter(x) {
                  return x.data.name;
                },
              },
              emphasis: {
                show: true,
              },
            },
            label: {
              show: true,
              color: '#333',
              fontWeight: 'bold',
            },
            force: this.force,
            data: data.nodes,
            links: data.links,
            // categories: categories,
            focusNodeAdjacency: true,
            roam: true,
            lineStyle: {
              color: 'source',
              curveness: 0,
              type: 'solid',
            },
          },
        ],
      };

      this.coAuthor.setOption(option);
      this.coAuthor.off('click');
      this.coAuthor.off('mouseover');
      this.coAuthor.on('click', function (p) {
        _this.$emit('graphClick', p);
      });
    },
  },
};
</script>

<style scoped></style>
